import { render, staticRenderFns } from "./DataTableFlyfood.vue?vue&type=template&id=dedc9e52&scoped=true"
import script from "./DataTableFlyfood.vue?vue&type=script&lang=js"
export * from "./DataTableFlyfood.vue?vue&type=script&lang=js"
import style0 from "./DataTableFlyfood.vue?vue&type=style&index=0&id=dedc9e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedc9e52",
  null
  
)

export default component.exports